export enum AvatarSize {
  Small,
  Medium,
  Big,
  Larger,
}
